import { mapMutations } from "vuex";
import paymentTerms from "../../paymentTerms/paymentTerms.vue";

export default {
  components: {
    paymentTerms,
  },
  mounted() {
    this.clearPromoCodeState();
  },
  methods: {
    ...mapMutations(["clearPromoCodeState"]),
  },
  computed: {
    cart() {
      return this.$store.getters.checkoutState.cart;
    },
  },
};
